import React from 'react'
import { IconX } from '@tabler/icons-react'
import pluralize from 'pluralize'

import { Button } from '@/components/buttons/Button'

import './BulkActions.scss'

export const BulkActions = ({
  selectedTaskIds,
  allPageSelected,
  allPagesSelected,
  hasMultiplePages,
  totalCount,
  onSelectAll,
  onSelectAllPages,
  onClear,
  onAction,
  actionLabel,
  updating,
}) => {
  const count = allPagesSelected ? totalCount : selectedTaskIds.length

  const selectedText = allPagesSelected
    ? `All ${pluralize('task', totalCount, true)} selected`
    : `${pluralize('task', count, true)} selected`

  const actionText = allPagesSelected
    ? `${actionLabel} all ${pluralize('task', totalCount, true)}`
    : `${actionLabel} ${pluralize('task', count, true)}`

  return (
    <div className="bulk-actions bulk-actions--visible" data-testid="inbox-bulk-actions">
      <div className="bulk-actions__left">
        <span className="bulk-actions__count">{selectedText}</span>
        {!allPageSelected && !allPagesSelected && (
          <Button link data-testid="inbox-select-all" onClick={onSelectAll}>
            Select all on page
          </Button>
        )}
        {allPageSelected && hasMultiplePages && !allPagesSelected && (
          <Button link data-testid="inbox-select-all-pages" onClick={onSelectAllPages}>
            Select all {totalCount.toLocaleString()} {pluralize('task', totalCount)} across all
            pages
          </Button>
        )}
      </div>
      <div className="bulk-actions__right">
        <Button brand data-testid="inbox-bulk-action" onClick={onAction} disabled={updating}>
          {updating ? `${actionLabel}ing...` : actionText}
        </Button>
        <div className="bulk-actions__separator" />
        <Button basic square onClick={onClear} aria-label="Clear selection">
          <IconX />
        </Button>
      </div>
    </div>
  )
}
